import { useSearchParams } from "react-router";
import { AbaCatalogo } from "./produtos/Catalogo";
import { AbaEstoque } from "./produtos/Estoque";

export function PaginaProdutosEstoque() {
  const [parametros, setParametros] = useSearchParams();
  const aba = parametros.get("aba") === "estoque" ? "estoque" : "catalogo";

  const irPara = (nova: "catalogo" | "estoque") => {
    const p = new URLSearchParams(parametros);
    p.set("aba", nova);
    setParametros(p, { replace: true });
  };

  return (
    <>
      <div className="abas" role="tablist" style={{ alignSelf: "flex-start" }}>
        <button role="tab" aria-selected={aba === "catalogo"} onClick={() => irPara("catalogo")}>
          Catálogo
        </button>
        <button role="tab" aria-selected={aba === "estoque"} onClick={() => irPara("estoque")}>
          Estoque por evento
        </button>
      </div>
      {aba === "catalogo" ? <AbaCatalogo /> : <AbaEstoque />}
    </>
  );
}
